import {
  IQuestionOption,
  QuestionType,
  SurveyQuestionResponse,
} from "../types/question";
import Question from "./question";

class SingleSelectQuestion extends Question {
  answer?: IQuestionOption;
  type: QuestionType;

  constructor(parameters: SurveyQuestionResponse) {
    super(parameters);
    this.type = QuestionType.SingleSelect;
  }

  setAnswer = (optionId: string) => {
    const option = this.options.find(
      (option) => option.referenceId === optionId
    );

    if (option) {
      if (option.referenceId === this.answer?.referenceId) {
        this.answer = undefined;
      } else {
        this.answer = option;
      }
    }
  };

  hasAnswer = (): boolean => {
    return !!this.answer;
  };

  getAnswer = (): IQuestionOption | undefined => {
    return this.answer;
  };

  resetAnswer = () => {
    this.answer = undefined;
  };

  isSingleSelect = (): boolean => {
    return true;
  };

  getAnswerIds = (): string[] => {
    return this.answer ? [this.answer.referenceId] : [];
  };
}

export default SingleSelectQuestion;
